<template>
  <FieldWrapper
    :label="label"
    :state="state"
    :configs="configs"
  >
    <div class="row">
      <div class="col my-custom-tree-select">
        <treeselect
          searchable
          search-nested
          open-on-click
          open-on-focus
          clear-on-select
          close-on-select
          :append-to-body="true"
          disable-branch-nodes

          :multiple="isMultiple"
          :clearable="!isRequired"

          v-model="selected"
          :disabled="disabled"
          :max-height="200"
          :placeholder="placeholder"
          :options="options"
          no-results-text="Nada encontrado"
          search-prompt-text="Buscar"
          :match-keys="['search', 'label']"
        />
      </div>
    </div>
  </FieldWrapper>
</template>

<script>
import treeselect from '@riophae/vue-treeselect'
import FieldWrapper from './FieldWrapper'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

export default {
  components: {
    treeselect,
    FieldWrapper
  },

  props: {
    type: {},
    value: {},
    state: {},
    label: {},
    configs: {},

    disabled: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      selected: this.value
    }
  },

  computed: {
    isMultiple () {
      return ['MULTISELECT', 'CHECKBOX'].includes(this.type)
    },

    placeholder () {
      return this.configs?.placeholder ?? 'Selecione uma opção'
    },

    isRequired () {
      return ['yes', 'y', 't', 'true', true].includes(this.configs?.fieldRequired)
    },

    options () {
      const values = this.configs?.values
      if (!Array.isArray(values)) return []

      return values.map((option) => {
        const search = clearStr(option.label)
        return { ...option, search }
      })
    }
  },

  watch: {
    selected (selected) {
      if (isEqual(selected, this.value)) return
      this.$emit('input', selected)
    },

    value (value) {
      if (isEqual(this.selected, value)) return
      this.selected = value
    }
  }
}

const clearStr = (str) => String(str || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim()
const isEqual = (val1, val2) => JSON.stringify(val1) === JSON.stringify(val2)
</script>

<style lang="sass">
  .my-custom-tree-select
    .tree-select
      & > .tree-select-dropdown
        z-index: 1000 !important
  .vue-treeselect__portal-target
    z-index: 9999 !important
</style>
